import React from 'react';
import { Field } from 'formik';
import { Row, Col, Input, Typography } from 'antd';
import PropTypes from 'prop-types';
import classes from './Style.module.scss';
import Panel from 'app/components/Layout/Panel';
import { Upload } from 'app/components/Form/Controls';

export default function Edit() {
  return (
    <Panel
      className={classes.additionalInformation}
      contentClassName={classes.content}
    >
      <Row>
        <Col xs={24} sm={12} lg={12}>
          <Field name="additionalInformation.documentLists">
            {({ field }) => {
              return (
                <div>
                  <Upload
                    dragger
                    shouldRemove
                    multiple
                    value={field.value ? [...field.value] : []}
                    supportText="Support: JPG, JPEG, PNG, PDF, DOC, XLSL"
                    accept={[
                      '.jpg',
                      '.jpeg',
                      '.png',
                      '.pdf',
                      '.doc',
                      '.docx',
                      '.xls',
                      '.xlsx'
                    ]}
                    onChange={(value) => {
                      field.onChange({
                        target: {
                          name: field.name,
                          value
                        }
                      });
                    }}
                  />
                </div>
              );
            }}
          </Field>
        </Col>
      </Row>
      <Field name="additionalInformation.remark">
        {({ field }) => {
          return (
            <div className={classes.remark}>
              <Typography.Title className={classes.title} level={4}>
                Remark
              </Typography.Title>
              <span className={classes.helper}>
                Please specify if there is any other special requirement.
              </span>
              <Input.TextArea
                value={field.value}
                onChange={(e) => {
                  field.onChange({
                    target: {
                      ...e.target,
                      name: field.name
                    }
                  });
                }}
                rows={5}
                placeholder="Fill here"
              />
            </div>
          );
        }}
      </Field>
    </Panel>
  );
}

Edit.propTypes = {
  hiddenTitle: PropTypes.bool
};
Edit.defaultProps = {
  hiddenTitle: false
};
